export default __webpack_public_path__ + "static/media/img3.f69a4c92.png";